import IndicatorIcon from '@assets/images/icons/indicator-icon.svg';
import { useAppSelector } from '@hooks/useAppSelector';
import { MotionImage, MotionText } from '@shared/atoms';
import classNames from 'classnames';
import React from 'react';
import styles from './index.module.scss';

interface CurrentPrioritiesCardProps {
  priority: {
    id: number;
    category: string;
    title: string;
    score: string;
    scoreClass: string;
    icon: JSX.Element | undefined | string;
    iconUrl: string | null;
    subCategory?: any;
  };
  handleRemovePriority: (id: number) => void;
  className?: string;
  'aria-labelledby'?: string;
  removeEnabled?: boolean;
}

export const CurrentPrioritiesCard: React.FC<CurrentPrioritiesCardProps> = ({
  priority,
  className,
  handleRemovePriority,
  'aria-labelledby': ariaLabelledBy,
  removeEnabled,
}) => {
  const {
    questionnaire,
    answers: stateAnswers,
    currentQuestionIndex,
  } = useAppSelector((state) => state.questionnaireV2 || {});

  const questions = questionnaire?.questionnairesV2Questions;

  return (
    <div className={styles.currentPriorityCard}>
      <div className={styles.currentPriorityContent}>
        <div className={styles.priorityInfoCurrent}>
          <div className={styles.icon}>
            {priority.icon ? (
              priority.icon
            ) : priority.iconUrl ? (
              <MotionImage
                src={priority.iconUrl}
                alt={`${priority.title} icon`}
                aria-hidden="true"
              />
            ) : (
              <MotionImage src={IndicatorIcon} alt={`${priority.title} icon`} aria-hidden="true" />
            )}
          </div>
          {priority?.category !== 'Indicator' && (
            <MotionText
              as="text"
              text={
                priority.subCategory
                  ? `${priority.title} > ${priority.subCategory}`
                  : priority.title
              }
              className={styles.categoryLabel}
            />
          )}
          {priority?.category === 'Indicator' && (
            <MotionText as="h4" text={priority.title} className={styles.categoryLabel} />
          )}
        </div>

        {removeEnabled && (
          <button
            className={styles.removeButton}
            onClick={(e) => {
              e.stopPropagation();
              handleRemovePriority(priority.id);
            }}
            aria-label={`Remove ${priority.title} from priorities`}
          >
            <i className={classNames('icon', 'icon-x', styles.btnRemoveIcon)} />
          </button>
        )}
      </div>

      <MotionText as="h4" text={priority.category} className={styles.priorityTitleCurrent} />
    </div>
  );
};

CurrentPrioritiesCard.defaultProps = {
  className: styles.answersContainer,
  'aria-labelledby': undefined,
  removeEnabled: true,
};
